import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualScrollControllerDirective } from './virtual-scroll-controller.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { AutocompleteScrollControllerDirective } from './autocomplete-scroll-controller.directive';

@NgModule({
  declarations: [VirtualScrollControllerDirective, AutocompleteScrollControllerDirective],
  imports: [CommonModule, ScrollingModule, MatSelectModule],
  exports: [VirtualScrollControllerDirective, AutocompleteScrollControllerDirective],
})
export class VirtualScrollControllerModule {}
